import { useMutation, useQuery } from "@tanstack/react-query";
import { IOfferState } from "../../interfaces/IOfferState";
import { customFetcher } from "../useFetch";
import { IOffer } from "../../interfaces/IOffer";
import { IOfferPosition } from "../../interfaces/IOfferPosition";
import { IOfferType } from "../../interfaces/IOfferType";

export const useGetOfferByProject = (idProject: number) => {
    const {
        data: offers,
        isLoading: isLoadingOfferByProject,
        refetch: refetechOfferByProject,
    } = useQuery<IOffer[]>({
        queryKey: ["offer/byProject", idProject],
        queryFn: () => customFetcher({ endpoint: `/offer/byProject/${idProject}` }),
    });

    return { offers, isLoadingOfferByProject, refetechOfferByProject };
};

export const useGetOfferPositionSmall = () => {
    const {
        data: offerPositionsSmall,
        isLoading: isLoadingOfferPositionsSmall,
        refetch: refetechOfferPositionsSmall,
    } = useQuery<IOffer[]>({
        queryKey: ["offer/position/small/"],
        queryFn: () => customFetcher({ endpoint: `offer/position/small/` }),
    });

    return { offerPositionsSmall, isLoadingOfferPositionsSmall, refetechOfferPositionsSmall };
};

export const useGetOfferSmall = () => {
    const {
        data: offersSmall,
        isLoading: isLoadingOfferSmall,
        refetch: refetechOfferSmall,
    } = useQuery<IOffer[]>({
        queryKey: ["offer/simple/"],
        queryFn: () => customFetcher({ endpoint: `/offer/simple/` }),
    });

    return { offersSmall, isLoadingOfferSmall, refetechOfferSmall };
};

export const useUpdateOffer = () => {
    const { mutateAsync: updateOffer, isPending: isPendingUpdateOffer } = useMutation({
        mutationFn: (currentObject: IOffer) =>
            customFetcher({
                endpoint: `/offer/${currentObject.id}`,
                method: "PUT",
                body: currentObject,
            }),
    });
    return {
        updateOffer,
        isPendingUpdateOffer,
    };
};

export const useUpdateOfferPositions = () => {
    const { mutateAsync: updateOfferPositions, isPending: isPendingUpdateOfferPositions } = useMutation({
        mutationFn: (currentObject: IOfferPosition[]) =>
            customFetcher({
                endpoint: `/offer/position/batchupdate/`,
                method: "PUT",
                body: currentObject,
            }),
    });
    return {
        updateOfferPositions,
        isPendingUpdateOfferPositions,
    };
};

export const useGetOfferState = () => {
    const {
        data: offerStateArray,
        isLoading: isLoadingOfferState,
        refetch: refetchOfferState,
    } = useQuery<IOfferState[]>({
        queryKey: ["offer/state/"],
        queryFn: () => customFetcher({ endpoint: "/offer/state/" }),
    });
    return { offerStateArray, isLoadingOfferState, refetchOfferState };
};

export const useGetOfferType = () => {
    const {
        data: offerTypeArray,
        isLoading: isLoadingOfferType,
        refetch: refetchOfferType,
    } = useQuery<IOfferType[]>({
        queryKey: ["offer/type/"],
        queryFn: () => customFetcher({ endpoint: "/offer/type/" }),
    });
    return { offerTypeArray, isLoadingOfferType, refetchOfferType };
};
